import { FC, memo, ReactElement, useRef, useState } from 'react'
import { Center, CenterProps } from '@chakra-ui/react'
import { callbackOnPressKey } from 'utils/events'

type Props = CenterProps & {
  isInvalid?: boolean
  isDisabled?: boolean
  children: ReactElement
  dispatchInputClick: () => void
}

export const DropzoneWrapper: FC<Props> = ({ isInvalid, isDisabled, children, dispatchInputClick, onDrop }) => {
  const [dragFileEnter, setDragFileEnter] = useState(false)

  const ref = useRef<HTMLDivElement | null>(null)

  return (
    <Center
      id="dropzone-upload"
      p={2}
      tabIndex={0}
      ref={ref}
      className="accessible-with-border"
      onClick={dispatchInputClick}
      onKeyUp={(event) => callbackOnPressKey(event, dispatchInputClick)}
      onDragEnter={() => setDragFileEnter(true)}
      onDragLeave={() => setDragFileEnter(false)}
      onDragOver={(event) => event.preventDefault()}
      onDrop={onDrop}
      width="100%"
      minHeight="100%"
      draggable="true"
      border="2px solid"
      rounded="md"
      bg="light"
      borderColor={isInvalid ? 'danger' : dragFileEnter ? 'primary' : 'borderColor'}
      color={dragFileEnter ? 'primary' : 'dark'}
      cursor={isDisabled ? 'not-allowed' : 'pointer'}
      opacity={isDisabled ? '0.4' : '1'}
      sx={
        isDisabled
          ? {}
          : {
              '&:hover, &:focus': {
                bg: 'lighterPrimary',
                color: 'primary',
                borderColor: 'primary',
                svg: {
                  color: 'primary',
                },
              },
            }
      }
    >
      {children}
    </Center>
  )
}

export default memo(DropzoneWrapper)
